<template>
  <div class="menu-wrap">
    <!-- 桌面端导航 -->
    <el-row :gutter="20" class="desktop-nav">
      <el-col :span="5" class="logo">
        <img src="../../assets/logo.png" alt="">
      </el-col>
      <el-col :span="12" class="headermenu">
        <div v-for="val in menuInfo" :key="val.id" class="menu-li-wrapper">
          <!-- 产品服务（id=2）使用弹出框 -->
          <el-popover
            v-if="val.id === 2"
            placement="bottom"
            trigger="hover"
            :visible-arrow="false"
            popper-class="service-popover"
            width="140">
            <template #reference>
              <div class="menu-li" :class="activeStatus === '/service' ? 'menuActive' : ''">{{ val.name }}</div>
            </template>
            <div class="popover-menu">
              <div class="popover-item" @click="goSubPage('solution')">解决方案</div>
              <div class="popover-item" @click="goSubPage('products')">全部商品</div>
            </div>
          </el-popover>
          <!-- 其他菜单项 -->
          <div v-else @click="goPage(val)" class="menu-li"
            :class="activeStatus == val.url ? 'menuActive' : ''">{{ val.name }}</div>
        </div>
      </el-col>
      <el-col :span="7" class="hedersetting">
        <div class="btn buy" @click="handleProcurement">我要采购</div>
        <div class="btn sell" @click="handleSupply">我要供货</div>
      </el-col>
    </el-row>

    <!-- 移动端导航 -->
    <div class="mobile-nav">
      <div class="mobile-logo">
        <img src="../../assets/logo.png" alt="">
      </div>
      <div class="mobile-btns">
        <span class="mobile-btn-text" @click="handleProcurement">我要采购</span>
        <span class="mobile-btn-text sell-text" @click="handleSupply">我要供货</span>
      </div>
      <div class="hamburger-btn" @click="toggleMobileMenu">
        <i class="el-icon-s-fold"></i>
      </div>
    </div>

    <!-- 移动端遮罩层 -->
    <div class="overlay" v-show="mobileMenuVisible" @click="toggleMobileMenu"></div>

    <!-- 移动端侧滑菜单 -->
    <div class="mobile-menu" :class="{ 'menu-open': mobileMenuVisible }">
      <div class="mobile-menu-header">
        <span class="menu-title">导航菜单</span>
        <span class="menu-close" @click="toggleMobileMenu">✕</span>
      </div>
      <div class="mobile-menu-list">
        <div v-for="val in menuInfo" :key="val.id">
          <!-- 产品服务（id=2）在移动端显示可展开子菜单 -->
          <template v-if="val.id === 2">
            <div class="mobile-menu-li" @click="toggleServiceSubMenu">
              <span>{{ val.name }}</span>
              <span class="sub-arrow" :class="{ 'arrow-up': serviceSubMenuVisible }">▸</span>
            </div>
            <div v-show="serviceSubMenuVisible" class="mobile-sub-menu">
              <div class="mobile-sub-item" @click="goSubPageMobile('solution')">解决方案</div>
              <div class="mobile-sub-item" @click="goSubPageMobile('products')">全部商品</div>
            </div>
          </template>
          <!-- 其他菜单项 -->
          <div v-else @click="goPageMobile(val)"
            class="mobile-menu-li"
            :class="activeStatus == val.url ? 'mobile-menu-active' : ''">
            {{ val.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileMenuVisible: false,
      serviceSubMenuVisible: false,
      menuInfo: [
        { id: 1, name: '首页', url: '/' },
        { id: 2, name: '产品服务', url: '/service' },
        { id: 5, name: '开放平台API', url: '' },
        { id: 6, name: '关于我们', url: '/about' },
      ],
      visible: false,
    }
  },
  computed: {
    activeStatus() {
      const path = this.$route.path
      const matched = this.menuInfo.find(item => {
        if (!item.url) return false
        if (item.url === '/') return path === '/'
        return path.startsWith(item.url)
      })
      return matched ? matched.url : null
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible
    },
    toggleServiceSubMenu() {
      this.serviceSubMenuVisible = !this.serviceSubMenuVisible
    },
    goSubPage(type) {
      this.$router.push({ path: '/service', query: { tab: type } })
    },
    goSubPageMobile(type) {
      this.mobileMenuVisible = false
      this.serviceSubMenuVisible = false
      this.goSubPage(type)
    },
    goPage(val) {
      if (val.id == 5) {
        window.open('https://s.apifox.cn/0d09ddbe-0532-45e7-a604-11b1e50f1b97', '_blank');
      } else {
        if (!val.url) return;
        this.$router.push(val.url)
      }
    },
    goPageMobile(val) {
      this.mobileMenuVisible = false
      this.goPage(val)
    },
    handleProcurement() {
      window.open('https://mancmss.birdicloud.com/#/index', '_blank');
    },
    handleSupply() {
      this.$message.success('敬请期待～');
      // this.$router.push('/supply')
    }
  }
}
</script>

<style lang="less" scoped>
@primary-color: #2376e3;

.menu-wrap {
  position: fixed;
  top: 0;
  width: 100vw;
  box-sizing: border-box;
  z-index: 99;
  background: #ffffff;

  // 桌面端导航
  .desktop-nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .logo {
    text-align: right;

    .name {
      font-size: 16px;
      color: @primary-color;
    }
  }

  .headermenu {
    height: 100%;
    display: flex;
    gap: 50px;
    justify-content: flex-start;

    .menu-li-wrapper {
      display: flex;
      align-items: center;
    }

    .menu-li {
      font-size: 18px;
      white-space: nowrap;
      cursor: pointer;
    }

    .menuActive {
      color: @primary-color;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .hedersetting {
    display: flex;

    .btn {
      width: 100px;
      padding: 5px 0;
      border-radius: 30px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;

      &:hover {
        transform: translateY(-2px) scale(1.05);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }

      &:active {
        transform: scale(0.97);
      }
    }

    .buy {
      background-color: #7bb2f9;

      &:hover {
        background-color: #5a9ff5;
        box-shadow: 0 6px 20px rgba(123, 178, 249, 0.4);
      }
    }

    .sell {
      margin-left: 20px;
      background-color: #fcca27;

      &:hover {
        background-color: #f5be00;
        box-shadow: 0 6px 20px rgba(252, 202, 39, 0.4);
      }
    }
  }

  // 移动端导航（默认隐藏）
  .mobile-nav {
    display: none;
  }

  // 移动端遮罩
  .overlay {
    display: none;
  }

  // 移动端侧滑菜单
  .mobile-menu {
    display: none;
  }
}

// ========== 移动端适配 ==========
@media (max-width: 768px) {
  .menu-wrap {
    padding: 8px 16px;

    // 隐藏桌面端导航
    .desktop-nav {
      display: none !important;
    }

    // 显示移动端导航
    .mobile-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .mobile-logo img {
        height: 32px;
      }

      .mobile-btns {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: auto;
        margin-right: 16px;

        .mobile-btn-text {
          font-size: 13px;
          color: #2376e3;
          white-space: nowrap;
          cursor: pointer;

          &.sell-text {
            color: #e6a800;
          }
        }
      }

      .hamburger-btn {
        width: 24px;
        height: 20px;
        position: relative;
        cursor: pointer;
        flex-shrink: 0;
        font-size: 22px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    // 遮罩层
    .overlay {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 100;
      transition: opacity 0.3s ease;
    }

    // 侧滑菜单
    .mobile-menu {
      display: block;
      position: fixed;
      top: 0;
      right: -280px;
      width: 260px;
      height: 100%;
      background: #fff;
      z-index: 101;
      transition: right 0.3s ease;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
      overflow-y: auto;

      &.menu-open {
        right: 0;
      }

      .mobile-menu-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #eee;

        .menu-title {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }

        .menu-close {
          font-size: 20px;
          color: #999;
          cursor: pointer;
        }
      }

      .mobile-menu-list {
        padding: 8px 0;

        .mobile-menu-li {
          padding: 14px 20px;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #f5f5f5;
          cursor: pointer;

          &:active {
            background: #f0f7ff;
          }
        }

        .mobile-menu-active {
          color: @primary-color;
          font-weight: bold;
          background: #f0f7ff;
        }

        .sub-arrow {
          display: inline-block;
          transition: transform 0.3s ease;
          font-size: 14px;
          color: #999;
          margin-left: 6px;

          &.arrow-up {
            transform: rotate(90deg);
          }
        }
      }

      .mobile-sub-menu {
        background: #f9fafb;

        .mobile-sub-item {
          padding: 12px 20px 12px 36px;
          font-size: 15px;
          color: #555;
          border-bottom: 1px solid #f0f0f0;
          cursor: pointer;

          &:active {
            background: #f0f7ff;
            color: @primary-color;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.service-popover {
  padding: 6px 0 !important;
  min-width: 120px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #e8e8e8 !important;

  .popover-menu {
    display: flex;
    flex-direction: column;
  }

  .popover-item {
    padding: 10px 20px;
    font-size: 15px;
    color: #333;
    cursor: pointer;
    white-space: nowrap;
    text-align: center;
    transition: background-color 0.2s, color 0.2s;

    &:hover {
      background-color: #f0f7ff;
      color: #2376e3;
    }

    &:active {
      background-color: #e0efff;
    }

    & + .popover-item {
      border-top: 1px solid #f0f0f0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue